import { Input, TextInput } from "@mantine/core";
import { MagnifyingGlassIcon } from "@phosphor-icons/react";

import { useExpeditionTabContextV2 } from "./ExpeditionTabV2.hooks";

export function ExpeditionTabFilterV2() {
  const { search } = useExpeditionTabContextV2();

  return (
    <div className="mb-4 flex items-center justify-center gap-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <TextInput
        label="Placa/Motorista"
        placeholder="Pesquisa"
        description="Informe a placa do veículo ou o nome do motorista"
        name="queue"
        rightSection={search?.value ? <Input.ClearButton onClick={search.onClear} /> : <MagnifyingGlassIcon weight="bold" />}
        onChange={(e) => {
          search?.onChange(e.target.value);
        }}
        value={search?.value}
        w="100%"
        required
      />
    </div>
  );
}
